import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMConst from 'lib/SMConst';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMOSpaceListTableRow extends React.Component {
  
  didSelect(e){
    if (!SMAppHelper.isMobile()) e.preventDefault();
    if(this.props.delegate && typeof this.props.delegate.tableDidSelectRowAtIndex === 'function'){
      this.props.delegate.tableDidSelectRowAtIndex(this.props.rowIndex);
    }
  }
  
  render() {
    let space = this.props.space;
    let name = SMFormatHelper.spaceName(space);
    let imageOverlay = "";
    let className = "dashboard-sidecol__scrollarea-list";
    let style = {};
    if (this.props.isCurrent) {
      className += ' is-current';
    }
    if (space.thumbnails && space.thumbnails.length > 0) {
      style["backgroundImage"] = 'url(' + space.cover_photo + ')';
    }
    
    if (!space.can_display) {
      imageOverlay = <p className="space-list__status">{I18n.t("dashboard.label_000118")}</p>;
    }
    else if (space.owner.status == SMConst.OwnerStatus.Banned || space.status == SMConst.Visibility.Hidden) {
      imageOverlay = <p className="space-list__status">{I18n.t("dashboard.label_000078")}</p>;
    }
    return (
      <li className={className}>
        <a href={Routes.owner_dashboard_space_path(space.owner.username, space.username)} 
          onClick={this.didSelect.bind(this)} 
          className="js-push-state dashboard-sidecol__scrollarea-list-link clearfix">
          {imageOverlay}
          <p className="space-list__img" style={style}>{name}</p>
          <p className="space-list__title">{name}</p>
        </a>
      </li>
    );
  }
}

SMOSpaceListTableRow.defaultProps = {
  rowIndex: 0,
  isCurrent: false,
};

export default SMOSpaceListTableRow;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/spaces/SMOSpaceListTableRow.jsx